import { Autocomplete, Avatar, Chip, Dialog, DialogContent, DialogTitle, FormHelperText, Grid, TextField, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { BackMobileIcon, CancelIcon, ErrorInfoIcon, InfoGroupChatIcon, InfoSecondaryIcon } from '../../icon';
import { Contact, Group, GroupChatModel } from '../../models/conversations';
import { OrgPlanTracker, PlanMetrics } from '../../models/plan-metrics.model';
import { MediaModel } from '../../models/templates.models';
import * as selector from '../../selectors/selectors';
import { SettingsService } from '../../services/SettingsService';
import { UserService } from '../../services/UserService';
import { UtilityService } from '../../services/UtilityService';
import { ViewTextLabels, appNote } from '../shared/constants';
import { validateForm } from '../shared/form-validation';
import MessageComposer from './message-composer';
import ScheduleMsgMobileComponent from './schedule-msg-mobile-component';

interface IProps {
    handleClose?: (success?: boolean) => void;
    GroupIDs?: string[];
    ContactIDs?: string[];
    open?: boolean;
    isScheduleMsg?: boolean;
    PhoneNumbers?: string[];
    showScheduleType?: boolean;
    Message?: string;
    ScheduleType?: number;
    ScheduledMessageID?: string;
    IsDuplicate?: boolean;
    ScheduleDateTime?: number;
    ScheduleEndDateTime?: number;
    Media?: MediaModel;
    showSignature?: boolean;
    bodySign?: string;
    signLength?: number;
    IsGroupChat?: boolean
    handleCloseGroupChat?: (success?: boolean) => void;
    handleSuccess?: () => void;
    UnsubscribeContactCount?: number;
    IsCampaign?: boolean;
    Campaign?: {
        ID: string;
        ToPhoneNumbers: string[];
        Name: string;
    };
    contact?: Contact;
    SetIscompaign?: (value: boolean) => void;
    MultiMedia?: MediaModel[];
    IsSecureChat?: boolean;
    ParticipantID?: string;
}

interface SendMessageAutoTypeOption {
    Type: SendMessageAutoTypeOptionType;
    ID: string;
    Name: string;
    PhoneNumber: string;
    Count: number;
}

enum SendMessageAutoTypeOptionType {
    CONTACT = "Contacts", GROUP = "Groups", RECENT = "Recently Contacted"
}

const SendMessageComponent = (props: IProps) => {
    const dispatch = useDispatch()
    const Groups: Group[] = useSelector(selector.groups);
    const Contacts: Contact[] = useSelector(selector.contacts);
    const UnSubscribed: Contact[] = useSelector(selector.getUnSubscribedContacts);
    const GetUnSubscribedContacts: Contact[] = useSelector(selector.getUnSubscribedContacts);
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const IsDarkMode: boolean = useSelector(selector.isDarkMode);
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics);
    const GetBlockedContacts: Contact[] = useSelector(selector.getBlockedContacts)
    const IsNewOrgFlow: boolean = useSelector(selector.isNewOrgFlow);
    const OrgPlanTracker: OrgPlanTracker = useSelector(selector.orgPlanTracker);

    const [limit, setLimit] = useState<number>()
    const [messageContactCount, setMessageContactCount] = useState<number>()
    const [phoneNumbers, setPhoneNumbers] = useState<string[]>(props.PhoneNumbers ? props.PhoneNumbers : [])
    const [contactIds, setContactIds] = useState<string[]>(() => {
        const initialContactIds = Contacts.filter(x =>
            // props.PhoneNumbers?.includes(UtilityService.unmaskPhoneNumber(x.PhoneNumber)) ||
            props.ContactIDs?.includes(x.ID)
        ).map(x => x.ID);
        if (props.contact && props.contact.ID) {
            if (!initialContactIds.includes(props.contact.ID)) {
                initialContactIds.push(props.contact.ID);
            }
        }
        return initialContactIds;
    });
    const [groupIds, SetGroupIds] = useState<string[]>(props.GroupIDs || [])
    const [uniqId, setUniqId] = useState<string>(uuid())
    const [options, setOptions] = useState<SendMessageAutoTypeOption[]>([])
    const [selectedOptions, setSelectedOptions] = useState<SendMessageAutoTypeOption[]>([])
    const [unsubscribedCount, setUnsubscribedCount] = useState<number>(props.UnsubscribeContactCount ? props.UnsubscribeContactCount : 0)
    const [blockedCount, setBlockedCount] = useState<number>(0)
    const [isScheduleMessage, setIsScheduleMessage] = useState<boolean>(!!props.showScheduleType)
    const [editValue, setEditValue] = useState<string>("")
    const [isEdit, setisEdit] = useState<boolean>(false)
    const [groupChat, setGroupChat] = useState<GroupChatModel>({
        ID: "",
        PhoneNumbers: props.PhoneNumbers ? props.PhoneNumbers : [],
        Name: "",
        UnReadCount: 0,
    })
    const [campaign, setCampaign] = useState<{
        ID: string;
        ToPhoneNumbers: string[];
        Name: string;
    }>({
        ID: props.Campaign?.ID ? props.Campaign.ID : "",
        ToPhoneNumbers: props.Campaign?.ID ? props.Campaign.ToPhoneNumbers : props.PhoneNumbers ? props.PhoneNumbers : [],
        Name: props.Campaign?.Name ? props.Campaign?.Name : "",
    })
    const [campaignNameError, setcampaignNameError] = useState('')
    const [isMobileSchedule, setIsMobileSchedule] = useState<boolean>(false);
    const [scheduleDateTime, setScheduleDateTime] = useState<number>(props.ScheduleDateTime ? props.ScheduleDateTime : -1);
    const [scheduleEndDateTime, setScheduleEndDateTime] = useState<number>(props.ScheduleEndDateTime ? props.ScheduleEndDateTime : -1);
    const [selectedScheduleType, setSelectedScheduleType] = useState<number>(props.ScheduleType ? props.ScheduleType : 0);
    const [toggleCampaign, setToggleCampaign] = useState<boolean>(!!props.Campaign?.ID ? true : false)
    const [contact, setContact] = useState<Contact>(props.contact ? props.contact : null);

    const getLimit = (GroupIDs?: string[], ContactIDs?: string[], Numbers?: string[]): number => {
        let groups = Groups.filter(x => GroupIDs?.includes(x.ID));
        let contactsFromGroups = groups.flatMap(x => x.Contacts || []);

        let contacts = Contacts.filter(x =>
            // props.PhoneNumbers?.includes(UtilityService.unmaskPhoneNumber(x.PhoneNumber)) ||
            ContactIDs?.includes(x.ID)).filter(x => props.IsGroupChat ? x : !x.IsUnsubscribed);

        let allConatcts = [...contactsFromGroups, ...contacts];

        allConatcts = allConatcts.filter((x, i) => allConatcts.findIndex(y => y?.ID === x?.ID) === i).filter(x => props.IsGroupChat ? x : !x.IsUnsubscribed);

        let enteredNumCount = !!Numbers ? props.IsGroupChat ? Numbers.length : Numbers.map(x => GetUnSubscribedContacts.find(y => UtilityService.maskPhoneNumberOnLength(y.PhoneNumber) === UtilityService.maskPhoneNumberOnLength(x))).filter(x => x === undefined).length : 0;

        return allConatcts.length + enteredNumCount;
    }

    useEffect(() => {
        setLimit(getLimit(props.GroupIDs, props.ContactIDs, props.PhoneNumbers))
        SettingsService.getSettingByCode(SettingsService.Message_Contacts_Code).then(res => {
            if (!!res)
                setMessageContactCount(parseInt(res.value) || 0)
        });
        setoptions()
    }, [])

    useEffect(() => {
        setLimit(getLimit(groupIds, contactIds, phoneNumbers))
    }, [Contacts])

    useEffect(() => {
        let ContactsFromSelectedGroups = Groups.filter(g => groupIds.includes(g.ID)).flatMap(x => x.Contacts || []).filter(e => !contactIds.includes(e.ID));
        setUnsubscribedCount(selectedOptions.map(x => GetUnSubscribedContacts.find(y => UtilityService.maskPhoneNumberOnLength(y.PhoneNumber) === UtilityService.maskPhoneNumberOnLength(x.PhoneNumber))).filter(z => z !== undefined).length + ContactsFromSelectedGroups?.filter((x, i) => ContactsFromSelectedGroups?.findIndex(y => y?.ID === x?.ID) === i).filter(x => x.IsUnsubscribed).length)
        setLimit(getLimit(groupIds, contactIds, phoneNumbers))
    }, [GetUnSubscribedContacts])

    useEffect(() => {
        const BlockedContacts = selectedOptions.filter(value => {
            return GetBlockedContacts.some(contact => UtilityService.maskPhoneNumberOnLength(contact.PhoneNumber) === UtilityService.maskPhoneNumberOnLength(value.PhoneNumber));
        });
        setBlockedCount(BlockedContacts.length)
    }, [GetBlockedContacts])

    const setoptions = () => {
        let options = Contacts.filter(x => props.IsGroupChat ? x : !x.IsUnsubscribed)
            .map((contact) => {
                return {
                    Type: SendMessageAutoTypeOptionType.CONTACT,
                    ID: contact.ID,
                    Name: contact.Name,
                    PhoneNumber: contact.PhoneNumber,
                    Count: 0
                } as SendMessageAutoTypeOption;
            }).sort((c: SendMessageAutoTypeOption, p: SendMessageAutoTypeOption) => c.Name > p.Name ? 1 : -1)
            .concat(props.PhoneNumbers?.filter((phoneNumber) =>
                !Contacts.some(contact => UtilityService.unmaskPhoneNumber(contact.PhoneNumber) === phoneNumber)
            ).map((phoneNumber) => {
                return {
                    Type: SendMessageAutoTypeOptionType.CONTACT,
                    ID: phoneNumber,
                    Name: UtilityService.maskPhoneNumberOnLength(phoneNumber),
                    PhoneNumber: UtilityService.maskPhoneNumberOnLength(phoneNumber),
                    Count: 0
                } as SendMessageAutoTypeOption;
            }) || []).sort((c: SendMessageAutoTypeOption, p: SendMessageAutoTypeOption) => c.Name > p.Name ? 1 : -1)
            .concat(
                Groups
                    .map((group) => {
                        return {
                            Type: SendMessageAutoTypeOptionType.GROUP,
                            ID: group.ID,
                            Name: group.Name,
                            PhoneNumber: "",
                            Count: group.ContactsCount
                        } as SendMessageAutoTypeOption;
                    }).filter(x => x.Count !== 0).sort((c: SendMessageAutoTypeOption, p: SendMessageAutoTypeOption) => c.Name > p.Name ? 1 : -1));

        let SelectedOptions = [...(options.filter((p) => props.GroupIDs?.includes(p.ID))), ...(options.filter((p) => props.PhoneNumbers?.includes(UtilityService.unmaskPhoneNumber(p.PhoneNumber)) || props.PhoneNumbers?.includes(UtilityService.unmaskPhoneNumberWithPlus(p.PhoneNumber)) || props.ContactIDs?.includes(p.ID))), ...selectedOptions];
        handleNumberStateOption(options, SelectedOptions);

        setSelectedOptions(SelectedOptions)
        setOptions(options)
        setGroupChat({ ...groupChat, PhoneNumbers: [] })
    }

    const handleNumberStateOption = (options, selectedOptions) => {
        if (contact) {
            const numberStateOption = options.find(opt => opt.ID === contact.ID);
            if (numberStateOption) {
                selectedOptions.push(numberStateOption);
            }
        }
    }

    const setTitle = () => {
        if (isScheduleMessage) {
            return `Scheduled Message`
        }
        else if (limit === 0 && props.IsCampaign) {
            return "Campaign (Group Broadcast)"
        }
        else if (limit === 0) { return ViewTextLabels.NEW_MESSAGE }
        else if (limit === 1 && !!selectedOptions[0]?.PhoneNumber && !UtilityService.isPhoneNumberValidWithRestrictedRange(UtilityService.unmaskPhoneNumberOnLength(selectedOptions[0]?.PhoneNumber))) {
            return `Conversation with ${!!selectedOptions[1]?.Name && UtilityService.trimMessage(selectedOptions[1]?.Name, 17)}`
        }
        else if (limit === 1) {
            const validOptions = selectedOptions.filter(option =>
                !UnSubscribed.some(unsub => unsub.PhoneNumber === option.PhoneNumber)
            );
            if (validOptions.length === 0) {
                return "New Message"
            } else {
                return `Conversation with ${!!validOptions[0]?.Name && UtilityService.trimMessage(validOptions[0]?.Name, 17)}`
            }
        }
        else {
            return `Campaign (Group Broadcast)`
        }
    }

    const showCreditsAvailable = () => {
        if (!IsNewOrgFlow) {
            let groupCreditsAvailable = PlanMetrics.GroupCreditsUsage.TotalCredits - PlanMetrics.GroupCreditsUsage.UsedCredits;
            let normalCreditsAvailable = PlanMetrics.NormalTextingUsage.TotalCredits - PlanMetrics.NormalTextingUsage.UsedCredits;

            if ((limit > 1 && PlanMetrics.GroupCreditsUsage.PlanCredits > 0) || (limit === 1 && PlanMetrics.NormalTextingUsage.PlanCredits > 0)) {
                if (props.IsGroupChat || limit > 1) {
                    return `Group Credits Available: ${groupCreditsAvailable > 0 ? groupCreditsAvailable : 0}`
                }
                else {
                    return `Credits Available: ${normalCreditsAvailable > 0 ? normalCreditsAvailable : 0}`
                }
            }
            else
                return ""
        } else {
            if (limit > 1 && ((OrgPlanTracker.GroupMsgCredits?.AddOns + OrgPlanTracker.GroupMsgCredits.Total) - OrgPlanTracker.GroupMsgCredits.Used) > 0) {
                return `Group Credits Available: ${((OrgPlanTracker.GroupMsgCredits?.AddOns + OrgPlanTracker.GroupMsgCredits.Total) - OrgPlanTracker.GroupMsgCredits.Used)}`
            }
        }
    }

    const handleClose = (success?: boolean) => {
        if (props.IsGroupChat) {
            // props.handleCloseGroupChat(success)
            props.handleClose(success);
        } else {
            props.handleClose(success);
        }
    }

    const isUserNumberAddedInGroup = () => {
        return props.IsGroupChat && selectedOptions.some(x => UtilityService.unmaskPhoneNumber(x.PhoneNumber) === UtilityService.unmaskPhoneNumber(UserService.getUserPhoneNumber()))
    }

    const getOptionDisabled = (option: any) => {
        return isScheduleMessage && (selectedOptions.filter(x => x.Type === "Contacts").length >= 1 && selectedOptions.filter(x => x.Type === "Groups").length === 0 ? option.Type === "Groups" : selectedOptions.filter(x => x.Type === "Groups").length >= 1)
    }

    const onChangeAutocomplete = (e: any, valueslist: any[]) => {
        if (valueslist.every((x: SendMessageAutoTypeOption) => x.Type === "Contacts"))
            valueslist.forEach((x, i) => {
                if (typeof x === "string" && UtilityService.validPhoneNumber(x)) {
                    let phoneNumber = UtilityService.unmaskPhoneNumber(x);
                    valueslist[i] = {
                        ID: phoneNumber.length === 10 ? `1${phoneNumber}` : phoneNumber,
                        Name: UtilityService.maskPhoneNumberOnLength(phoneNumber.length === 10 ? `1${phoneNumber}` : phoneNumber),
                        PhoneNumber: phoneNumber.length === 10 ? `1${phoneNumber}` : phoneNumber,
                        Type: SendMessageAutoTypeOptionType.CONTACT
                    } as SendMessageAutoTypeOption
                }
            });

        let selectedOptions: SendMessageAutoTypeOption[] = valueslist.filter((x, i) => typeof x !== "string");

        selectedOptions = selectedOptions.filter((x, index) => selectedOptions.findIndex(y => y.ID === x.ID) === index)

        let contactIds = selectedOptions.filter(x => x.Type === SendMessageAutoTypeOptionType.CONTACT && UtilityService.unmaskPhoneNumberOnLength(x.ID) !== UtilityService.unmaskPhoneNumberOnLength(x.PhoneNumber)).map(x => x.ID);

        let groupIds: string[] = selectedOptions.filter(x => x.Type === SendMessageAutoTypeOptionType.GROUP).map(x => x.ID);

        let contactsFromSelectedGroups = Groups.filter(g => groupIds.includes(g.ID)).flatMap(x => x.Contacts || []).filter(e => !contactIds.includes(e.ID));
        // let selectedConatcts = Contacts.filter(e => contactIds.includes(e.ID));        

        let unsubscribedCount: number = selectedOptions.map(x => GetUnSubscribedContacts.find(y => UtilityService.maskPhoneNumberOnLength(y.PhoneNumber) === UtilityService.maskPhoneNumberOnLength(x.PhoneNumber))).filter(z => z !== undefined).length + contactsFromSelectedGroups.filter(x => x.IsUnsubscribed).length

        // let blockedCount = selectedConatcts.filter(x => x.IsBlocked).length + contactsFromSelectedGroups.filter(x => x.IsBlocked).length;

        const BlockedContacts = valueslist.filter(value => {
            return GetBlockedContacts.some(contact => UtilityService.maskPhoneNumberOnLength(contact.PhoneNumber) === UtilityService.maskPhoneNumberOnLength(value.PhoneNumber));
        });
        let blockedCount = BlockedContacts.length;


        let numbers = selectedOptions.filter(x => UtilityService.isPhoneNumberValidWithRestrictedRange(UtilityService.unmaskPhoneNumberOnLength(x.PhoneNumber)) && UtilityService.unmaskPhoneNumberOnLength(x.ID) === UtilityService.unmaskPhoneNumberOnLength(x.PhoneNumber)).map((x: any) => UtilityService.unmaskPhoneNumberOnLength(x.PhoneNumber));

        setPhoneNumbers(numbers)
        setContactIds(contactIds)
        SetGroupIds(groupIds)
        setLimit(getLimit(groupIds, contactIds, numbers))
        setSelectedOptions(selectedOptions)
        if (!!props.Campaign?.ID) setToggleCampaign(false)
        setUnsubscribedCount(unsubscribedCount)
        setBlockedCount(blockedCount)
        setOptions(options.filter(x => x.Type === SendMessageAutoTypeOptionType.CONTACT ? UtilityService.unmaskPhoneNumber(x.ID) !== UtilityService.unmaskPhoneNumber(x.PhoneNumber) : true));
        props.IsGroupChat && setGroupChat({ ...groupChat, PhoneNumbers: numbers.concat(Contacts.filter(x => contactIds?.includes(x.ID)).map(x => UtilityService.unmaskPhoneNumber(x.PhoneNumber))) })
    }

    const handleBlur = (event: any) => {
        let phoneNumber = event?.target?.value;
        phoneNumber = UtilityService.unmaskPhoneNumberOnLength(phoneNumber);
        if (!!phoneNumber) {
            setEditValue("")
            setisEdit(false)
            let contact = Contacts.find(x => UtilityService.unmaskPhoneNumberOnLength(x.PhoneNumber).endsWith(phoneNumber));
            onChangeAutocomplete(event, [
                ...selectedOptions,
                {
                    ID: !!contact ? contact.ID : phoneNumber.length === 10 ? `1${phoneNumber} ` : phoneNumber,
                    Name: !!contact ? contact.Name : UtilityService.maskPhoneNumberOnLength(phoneNumber.length === 10 ? `1${phoneNumber} ` : phoneNumber),
                    PhoneNumber: !!contact ? contact.PhoneNumber : phoneNumber.length === 10 ? `1${phoneNumber} ` : phoneNumber,
                    Type: SendMessageAutoTypeOptionType.CONTACT
                } as SendMessageAutoTypeOption
            ]);
        }
    }

    const onEditNumber = async (e, editvalue) => {
        let sOptions = selectedOptions.filter(x => x.PhoneNumber !== editvalue)
        setSelectedOptions(sOptions)
        setEditValue(editvalue)
        setisEdit(true)
        if (isEdit && !!editValue && editValue != editvalue) {
            let phoneNumber = UtilityService.unmaskPhoneNumberOnLength(editValue);
            let contact = Contacts.find(x => UtilityService.unmaskPhoneNumberOnLength(x.PhoneNumber).endsWith(phoneNumber));
            await onChangeAutocomplete(e, [
                ...sOptions,
                {
                    ID: contact ? contact.ID : phoneNumber.length === 10 ? `1${phoneNumber} ` : phoneNumber,
                    Name: !!contact ? contact.Name : UtilityService.maskPhoneNumberOnLength(phoneNumber.length === 10 ? `1${phoneNumber} ` : phoneNumber),
                    PhoneNumber: !!contact ? contact.PhoneNumber : phoneNumber.length === 10 ? `1${phoneNumber} ` : phoneNumber,
                    Type: SendMessageAutoTypeOptionType.CONTACT
                } as SendMessageAutoTypeOption
            ]);
        }
    }

    const handlePasteNumbers = (event) => {
        event.preventDefault();
        const phoneNumber = event?.clipboardData?.getData("text").trim();
        const phoneNumbers = phoneNumber.split(/[,|\n]+/).filter(x => !!UtilityService.unmaskPhoneNumberOnLength(x))

        if (!!phoneNumbers.length) {
            const phoneNumberData = phoneNumbers.map(x => {
                let unmaskNumber = UtilityService.unmaskPhoneNumberOnLength(x);
                let contact = Contacts.find(y => UtilityService.unmaskPhoneNumberOnLength(y.PhoneNumber).endsWith(unmaskNumber));
                let numbers = {
                    ID: !!contact ? contact.ID : unmaskNumber.length === 10 ? `1${unmaskNumber} ` : unmaskNumber,
                    Name: !!contact ? contact.Name : UtilityService.maskPhoneNumberOnLength(unmaskNumber.length === 10 ? `1${unmaskNumber} ` : unmaskNumber),
                    PhoneNumber: !!contact ? contact.PhoneNumber : unmaskNumber.length === 10 ? `1${unmaskNumber} ` : unmaskNumber,
                    Type: SendMessageAutoTypeOptionType.CONTACT
                }
                return numbers;
            })
            onChangeAutocomplete(event, [
                ...selectedOptions,
                ...phoneNumberData]);
        }
    }

    const handleInputChange = (event: any, newInput: string, reason) => {
        let phoneNumber = event?.target?.value;
        if (reason === "reset" && isEdit) {
            setEditValue(editValue)
        }
        else {
            setisEdit(false)
            setEditValue(newInput)
        }
        if (!!phoneNumber && phoneNumber.trim().slice(phoneNumber.length)) {
            phoneNumber = UtilityService.unmaskPhoneNumberOnLength(phoneNumber);
            let contact = Contacts.find(x => UtilityService.unmaskPhoneNumberOnLength(x.PhoneNumber).endsWith(phoneNumber));
            onChangeAutocomplete(event, [
                ...selectedOptions,
                {
                    ID: contact ? contact.ID : phoneNumber.length === 10 ? `1${phoneNumber} ` : phoneNumber,
                    Name: !!contact ? contact.Name : UtilityService.maskPhoneNumberOnLength(phoneNumber.length === 10 ? `1${phoneNumber} ` : phoneNumber),
                    PhoneNumber: !!contact ? contact.PhoneNumber : phoneNumber.length === 10 ? `1${phoneNumber} ` : phoneNumber,
                    Type: SendMessageAutoTypeOptionType.CONTACT
                } as SendMessageAutoTypeOption
            ]);
        }
    }

    const editGroupChat = (name: any, value: any) => {
        setGroupChat({ ...groupChat, [name]: value })
    }


    const isDisabled = () => {
        if (props.IsSecureChat) {
            return false
        }
        else {
            if (!!props.IsGroupChat) {
                return limit < 2 || limit > 9 || isUserNumberAddedInGroup() || groupChat?.Name.length > 75 || limit > messageContactCount
            }
            else if (props.IsCampaign || limit > 1) {
                return limit < 2 || !!campaignNameError || !campaign.Name.length || limit > messageContactCount
            }
            else {
                return isScheduleMessage && (groupIds.length && phoneNumbers.length) > 0 ? true : limit === 0 || limit > messageContactCount
            }
        }
    }

    const isSelectionCriteriaMatching = () => {
        return (selectedOptions.filter(x => x.Type === "Contacts").length >= 1 && selectedOptions.filter(x => x.Type === "Groups").length === 0) || (selectedOptions.filter(x => x.Type === "Contacts").length === 0 && selectedOptions.filter(x => x.Type === "Groups").length === 1)
    }

    const handleScheduleTypeChange = (isScheduleMessage: boolean) => {
        setIsScheduleMessage(isScheduleMessage)
        if (isScheduleMessage && !isSelectionCriteriaMatching()) {
            setSelectedOptions([])
            setLimit(0)
        }
    }

    const onSave = (scheduleDateTime: number, selectedScheduleType: number) => {
        setScheduleDateTime(scheduleDateTime === -1 || scheduleDateTime === undefined ? UtilityService.roundTimeToMinutes(new Date().getTime(), 10) : scheduleDateTime)
        setSelectedScheduleType(selectedScheduleType)
        setIsMobileSchedule(false)
    }

    const SetIsMobileSchedule = (confirm: boolean) => {
        if (confirm) {
            setIsMobileSchedule(!isMobileSchedule)
        }
        else {
            setScheduleDateTime(-1)
            setScheduleEndDateTime(-1)
        }
    }

    const editCampaign = (name: any, value: any) => {
        validateForm({ campaignname: value }, (validationErrors) => {
            setcampaignNameError(validationErrors.campaignname || "")
        });
        setCampaign({ ...campaign, Name: value })
    }

    const getRecentlyCreatedContacts = () => {
        const contactsWithDates = Contacts
            .filter(c => c.CreatedDateTime)
            .sort((a, b) => {
                const dateA = new Date(a.CreatedDateTime).getTime();
                const dateB = new Date(b.CreatedDateTime).getTime();
                return dateB - dateA;
            })
            .slice(0, 5)
            .filter(c => !selectedOptions.some(selected => selected.ID === c.ID))
            .filter(c => props.IsGroupChat ? !c.IsUnsubscribed : !c.IsUnsubscribed)
            .map(contact => ({
                Type: SendMessageAutoTypeOptionType.RECENT,
                ID: contact.ID,
                Name: contact.Name,
                PhoneNumber: contact.PhoneNumber,
                Count: 0
            } as SendMessageAutoTypeOption));

        return contactsWithDates;
    };

    return (IsMobileDevice ?
        <div className={`${IsDarkMode ? "bg-color-sidebar-bg" : "paper-background"} o-x-hidden w-fill h-v-100`}>
            <div className="p-2 d-flex b-shadow-mobile-header" id="customized-dialog-title">
                <BackMobileIcon className={"c-pointer mr-1 my-auto"} onClick={() => handleClose()} />
                <span className={"n-msg-title h3 my-auto"}>
                    {props.IsGroupChat ? <span className={"h2-semibold"}> {ViewTextLabels.GROUP_CHAT} </span> : <span className={"h2-semibold"}>{setTitle()}</span>}
                </span>
            </div>
            <div className={`pt-2 pb-10 p-relative px-2 o-hidden ${isMobileSchedule && "d-none"} ${IsMobileDevice && "mt-2"}`}>
                <Grid container spacing={2}>
                    {!props.IsSecureChat && <Grid item xs={12}>
                        <span className={"d-flex flex-direction my-1"}>
                            {isUserNumberAddedInGroup() &&
                                <div className={"h6-regular color-primary-danger ml-1"}>
                                    You cannot add your own number while creating a groupchat
                                </div>}
                            {
                                (props.IsGroupChat && limit > 9) ?
                                    <div className={"h6-regular color-primary-danger ml-1"}>
                                        You can only create groupchat with maximum 9 contacts
                                    </div>
                                    : !!limit && limit > messageContactCount &&
                                    <div className={"h6-regular color-primary-danger ml-1"}>
                                        You can only send upto {messageContactCount} contacts at once
                                    </div>
                            }
                            {
                                isScheduleMessage && (groupIds.length && phoneNumbers.length && selectedOptions.length) > 0 ? <div className={"h6-regular color-primary-danger ml-1"}>
                                    {appNote.SCHEDULE_MESSAGE_RESTRICTION}
                                </div> : null
                            }
                            <Autocomplete
                                className={"p-1', notchedOutline:'br-text-field br-2"}
                                id="multiple-limit-tags"
                                multiple
                                autoHighlight
                                options={[
                                    // ...getRecentlyCreatedContacts(),
                                    ...(props.IsGroupChat
                                        ? options.filter(x => x.Type === SendMessageAutoTypeOptionType.CONTACT).filter(x => !selectedOptions.includes(x))
                                        : options.filter(x => !selectedOptions.some(selected => selected.ID === x.ID)))
                                ]}
                                groupBy={(option) => option.Type}
                                getOptionLabel={(option) => option.Name + option.PhoneNumber}
                                getOptionDisabled={getOptionDisabled}
                                onChange={onChangeAutocomplete}
                                value={selectedOptions}
                                classes={{
                                    option: "custom-option",
                                    groupLabel: "custom-group-label",
                                    groupUl: "m-1",
                                    popper: "bg-color-secondary"
                                }}
                                onBlur={handleBlur}
                                renderOption={(defaultprops, option: any) => (
                                    <li {...defaultprops} className={`h4-regular font-bold p-1 d-flex justify-between w-p-90 ${getOptionDisabled(option) ? 'disabled color-secondary-light' : 'c-pointer'}`}>
                                        <div>{!!option.Name ? UtilityService.trimMessage(option.Name, 13) : option.Name}</div>
                                        <div>
                                            {!option.PhoneNumber ? option.Count >= 0 &&
                                                <div className={getOptionDisabled(option) ? 'disabled color-secondary-light' : 'badge-label'}>
                                                    {option.Count}
                                                </div>
                                                : UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)}
                                        </div>
                                    </li>
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option: SendMessageAutoTypeOption, index) => (
                                        <Chip
                                            avatar={option.Count > 0 ? <Avatar> {option.Count}</Avatar>
                                                : <span className={"d-none"} />}
                                            classes={{
                                                colorPrimary: !!option.PhoneNumber ?
                                                    ((UtilityService.isPhoneNumberValidWithRestrictedRange(UtilityService.unmaskPhoneNumberOnLength(option.PhoneNumber))) && (!props.IsGroupChat && GetUnSubscribedContacts.find(x => UtilityService.maskPhoneNumberOnLength(x.PhoneNumber) === UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)))) ? "custom-color-chip-5"
                                                        : (UtilityService.isPhoneNumberValidWithRestrictedRange(UtilityService.unmaskPhoneNumberOnLength(option.PhoneNumber))) ? "custom-color-chip-1" : "custom-color-chip-4" : "custom-color-chip-2",
                                                avatarColorPrimary: "custom-chip-avatar",
                                                colorSecondary: !!option.Name
                                                    ? "custom-color-chip-3" : "custom-color-chip-4"
                                            }}
                                            color={!!option.Name ? "primary" : "secondary"}
                                            label={!!option.Name ? option.Name : "notValid"}
                                            {...getTagProps({ index })}
                                            onClick={option.Count > 0 ? null : (e) => (!UtilityService.isPhoneNumberValidWithRestrictedRange(UtilityService.unmaskPhoneNumberOnLength(option.PhoneNumber))) && onEditNumber(e, option.PhoneNumber)}
                                        />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField {...params}
                                        required
                                        autoFocus
                                        label="To"
                                        variant='outlined'
                                        placeholder={props.IsGroupChat ? selectedOptions.length === 0 && "Type a name or phone number" : selectedOptions.length === 0 && "Type a name, group name or phone number"}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{ tabIndex: 10, ...params.inputProps, onPaste: handlePasteNumbers }}
                                        onKeyDown={e => {
                                            if (e && e.key === 'Enter') {
                                                handleBlur(e);
                                            }
                                        }}
                                    />
                                )}
                                onInputChange={handleInputChange}
                                inputValue={editValue}
                            />
                            <div className={"h5-regular color-secondary-accent ml-1 d-flex justify-between"}>
                                <span >
                                    Added Contacts: {limit}/{props.IsGroupChat ? 9 : messageContactCount}
                                </span>

                                {!!unsubscribedCount && !props.IsGroupChat && <span> Unsubscribed contacts : {unsubscribedCount}</span>}
                            </div>
                        </span>
                        {
                            props.IsGroupChat &&
                            <div className=''>
                                <TextField
                                    name="Name"
                                    label="Group Chat Name"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={groupChat?.Name}
                                    onChange={(e) =>
                                        editGroupChat(e.target.name, e.target.value)}
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'
                                    className={"my-1"}
                                />
                                {groupChat?.Name.length > 75 &&
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        Name should not exceed 75 characters
                                    </FormHelperText>}
                            </div>
                        }
                        {
                            (!props.IsGroupChat && (props.IsCampaign || limit > 1)) && <div className='mx-1'>
                                <TextField
                                    name="Campaignname"
                                    label="Campaign Name *"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={campaign?.Name}
                                    onChange={(e) => editCampaign(e.target.name, e.target.value)}
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'
                                    className={"my-1"}
                                    disabled={toggleCampaign}
                                />
                                {!!campaignNameError &&
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {campaignNameError}
                                    </FormHelperText>}
                            </div>
                        }
                    </Grid>}
                    <Grid item xs={12}>
                        <MessageComposer
                            GroupChat={groupChat}
                            IsGroupChat={props.IsGroupChat}
                            HandleClose={handleClose}
                            ShowScheduleType={props.showScheduleType}
                            Message={props.Message}
                            ScheduleType={selectedScheduleType}
                            ScheduleDateTime={scheduleDateTime}
                            ScheduleEndDateTime={scheduleEndDateTime}
                            IsNewMessage={true}
                            UniqId={uniqId}
                            GroupIDs={groupIds}
                            PhoneNumbers={phoneNumbers}
                            IsDisabled={isDisabled()}
                            Limit={limit}
                            UnsubscribedCount={unsubscribedCount}
                            BlockedCount={blockedCount}
                            ContactIDs={contactIds}
                            ScheduledMessageID={(!toggleCampaign && props.Campaign?.ID) ? "" : props.ScheduledMessageID}
                            IsDuplicate={props.IsDuplicate}
                            HandleScheduleTypeChange={handleScheduleTypeChange}
                            showSignature={props.showSignature}
                            bodySign={props.bodySign}
                            signLength={props.signLength}
                            handleSuccess={props.handleSuccess}
                            IsAddRule={false}
                            setIsMobileSchedule={SetIsMobileSchedule}
                            Campaign={campaign}
                            IsCamPaign={props.IsCampaign}
                            MultiMedia={props.MultiMedia}
                            IsSecureChat={props.IsSecureChat}
                            ParticipantId={props.ParticipantID}
                        />
                    </Grid>
                </Grid>
            </div>
            {isMobileSchedule && <ScheduleMsgMobileComponent onClose={() => { setIsMobileSchedule(false) }} onSave={onSave} selectedScheduleType={selectedScheduleType} scheduleDateTime={scheduleDateTime} IsMobileDevice={IsMobileDevice} IsSecureChat={props.IsSecureChat} />}
        </div >
        :
        <Dialog
            fullWidth
            maxWidth="sm"
            open={props.open}
            onClose={(event, reason) => {
                // if (reason !== 'backdropClick') {
                // props.handleClose()
                // }
            }}
            aria-labelledby="responsive-dialog-title"
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
            disableEscapeKeyDown
            classes={{ paper: "min-h-40" }}
            PaperProps={IsDarkMode ? {
                className: 'bg-color-sidebar-bg',
            } : { sx: { filter: "drop-shadow(0px 1px 4px #7090b033)" } }}
        >
            <DialogTitle className="p-2" id="customized-dialog-title">
                <span className={"d-flex align-center justify-between color-primary-accent"}>
                    {props.IsGroupChat ?
                        <div className='d-flex align-center'><span className={"h2-semibold"}>{ViewTextLabels.GROUP_CHAT}</span>
                            <Tooltip title={appNote.GROUP_CHAT_TO_BUTTON_INFO} placement="bottom-start" >
                                <InfoGroupChatIcon className='pl-1' /></Tooltip>
                        </div> :
                        <span className={"h2-semibold"}>{setTitle()}
                            {
                                (!props.IsGroupChat && (props.IsCampaign || selectedOptions.length > 1 || selectedOptions.some(option => option.Type === "Groups" && option.Count > 1))) && <Tooltip title={appNote.CAMPAIGN_CHAT_TO_BUTTON_INFO} placement="bottom-start" >
                                    <InfoGroupChatIcon className='pl-1' /></Tooltip>
                            }
                        </span>
                    }
                    {
                        !!showCreditsAvailable() &&
                        <span className={"h5-regular f-w-bold ml-auto my-auto mr-2"}>{showCreditsAvailable()}</span>
                    }
                    <Tooltip title='Close' placement='bottom'><CancelIcon className={`c-pointer`} onClick={() => handleClose()} /></Tooltip>
                </span>
            </DialogTitle>
            <div className={"bb-primary-background-pink-4 mx-2"}></div>
            <DialogContent className={"px-1 o-x-hidden my-2 "} classes={{ root: "py-0" }}>
                <Grid container spacing={1}>
                    {!props.IsSecureChat && <Grid item xs={12}>
                        {isUserNumberAddedInGroup() &&
                            <div className={"h6-regular color-primary-danger ml-1"}>
                                You cannot add your own number while creating a groupchat
                            </div>}
                        {
                            (props.IsGroupChat && limit > 9) ?
                                <div className={"h6-regular color-primary-danger ml-1"}>
                                    You can only create groupchat with maximum 9 contacts
                                </div>
                                : !!limit && limit > messageContactCount &&
                                <div className={"h6-regular color-primary-danger ml-1"}>
                                    You can only send upto {messageContactCount} contacts at once
                                </div>
                        }
                        <Autocomplete
                            className={"p-1"}
                            id="multiple-limit-tags"
                            multiple
                            autoHighlight
                            options={[
                                // ...getRecentlyCreatedContacts(),
                                ...(props.IsGroupChat
                                    ? options.filter(x => x.Type === SendMessageAutoTypeOptionType.CONTACT).filter(x => !selectedOptions.includes(x))
                                    : options.filter(x => !selectedOptions.some(selected => selected.ID === x.ID)))
                            ]}
                            groupBy={(option) => option.Type}
                            getOptionLabel={(option) => option.Name + option.PhoneNumber}
                            getOptionDisabled={getOptionDisabled}
                            onChange={onChangeAutocomplete}
                            value={selectedOptions}
                            classes={{
                                option: "custom-option",
                                groupLabel: "custom-group-label",
                                groupUl: "m-1",
                                popper: "",
                                input: ` color-text-field-font h4-regular`
                            }}
                            onBlur={handleBlur}
                            renderOption={(props, option: any) => (
                                <li {...props}>
                                    <div className={`h4-regular font-bold py-2 d-flex justify-between w-p-95 o-x-hidden ${getOptionDisabled(option) ? 'disabled color-secondary-light' : 'c-pointer'}`}>
                                        <div className=''>
                                            {option.Name}
                                        </div>
                                        <div className='  '>
                                            {!option.PhoneNumber ? option.Count >= 0 &&
                                                <div className={getOptionDisabled(option) ? 'disabled color-secondary-light' : 'badge-label'}>
                                                    {option.Count}
                                                </div>
                                                : UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)}
                                        </div>
                                    </div>
                                </li>
                            )}
                            renderTags={(value, getTagProps) =>
                                value.map((option: SendMessageAutoTypeOption, index) => (
                                    <Chip
                                        avatar={option.Count > 0 ? <Avatar> {option.Count}</Avatar>
                                            : <span className={"d-none"} />}
                                        classes={{
                                            colorPrimary: !!option.PhoneNumber ?
                                                (UtilityService.isPhoneNumberValidWithRestrictedRange(UtilityService.unmaskPhoneNumberOnLength(option.PhoneNumber)) && (!props.IsGroupChat && GetUnSubscribedContacts.find(x => UtilityService.maskPhoneNumberOnLength(x.PhoneNumber) === UtilityService.maskPhoneNumberOnLength(option.PhoneNumber)))) ? "custom-color-chip-5"
                                                    : UtilityService.isPhoneNumberValidWithRestrictedRange(UtilityService.unmaskPhoneNumberOnLength(option.PhoneNumber)) ? "custom-color-chip-1" : "custom-color-chip-4" : "custom-color-chip-2",
                                            avatarColorPrimary: "custom-chip-avatar",
                                            colorSecondary: !!option.Name
                                                ? "custom-color-chip-3" : "custom-color-chip-4"
                                        }}
                                        color={!!option.Name ? "primary" : "secondary"}
                                        label={!!option.Name ? option.Name : "notValid"}
                                        {...getTagProps({ index })}
                                        onClick={option.Count > 0 ? null : (e) => (!UtilityService.isPhoneNumberValidWithRestrictedRange(UtilityService.unmaskPhoneNumberOnLength(option.PhoneNumber))) && onEditNumber(e, option.PhoneNumber)}
                                    />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField {...params}
                                    required
                                    label="To"
                                    variant='outlined'
                                    placeholder={props.IsGroupChat ? selectedOptions.length === 0 && "Type a name or phone number" : selectedOptions.length === 0 && "Type a name, group name or phone number"}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{ tabIndex: 10, ...params.inputProps, onPaste: handlePasteNumbers }}
                                    onKeyDown={e => {
                                        if (e && e.key === 'Enter') {
                                            handleBlur(e);
                                        }
                                    }}
                                />
                            )}
                            onInputChange={handleInputChange}
                            inputValue={editValue}
                        />
                        <div className={"h6-regular color-send-msg-content mx-1 d-flex justify-between"}>
                            <span>
                                Added Contacts: {limit}/{props.IsGroupChat ? 9 : messageContactCount}
                                {isScheduleMessage && <Tooltip title={appNote.SCHEDULE_MESSAGE_RESTRICTION} placement="bottom-start" >
                                    {isScheduleMessage && (groupIds.length && selectedOptions.length && (contactIds.length || phoneNumbers.length)) > 0 ? <ErrorInfoIcon className='pl-1' /> : <InfoSecondaryIcon className='pl-1' />}
                                </Tooltip>}
                            </span>
                            {!!unsubscribedCount && !props.IsGroupChat && <span>Unsubscribed contacts : {unsubscribedCount}</span>}
                        </div>

                        {
                            props.IsGroupChat &&
                            <div className='mx-1'>
                                <TextField
                                    name="Name"
                                    label="Group Chat Name"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={groupChat?.Name}
                                    onChange={(e) =>
                                        editGroupChat(e.target.name, e.target.value)}
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'
                                    className={"my-1"}
                                />
                                {groupChat?.Name.length > 75 &&
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        Name should not exceed 75 characters
                                    </FormHelperText>}
                            </div>
                        }
                        {
                            (!props.IsGroupChat && (props.IsCampaign || limit > 1
                            )) && <div className='mx-1'>
                                <TextField
                                    name="Campaignname"
                                    label=" Campaign Name *"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={campaign?.Name}
                                    onChange={(e) => editCampaign(e.target.name, e.target.value)}
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'
                                    className={"my-1"}
                                    disabled={toggleCampaign}
                                />
                                {!!campaignNameError &&
                                    <FormHelperText className="h5 color-primary-danger t-align-right">
                                        {campaignNameError}
                                    </FormHelperText>}
                            </div>
                        }
                    </Grid>
                    }

                    <Grid item xs={12}>
                        <MessageComposer
                            GroupChat={groupChat}
                            IsGroupChat={props.IsGroupChat}
                            HandleClose={handleClose}
                            ShowScheduleType={props.showScheduleType}
                            Message={props.Message}
                            ScheduleType={props.ScheduleType}
                            ScheduleDateTime={props.ScheduleDateTime}
                            ScheduleEndDateTime={props.ScheduleEndDateTime}
                            IsNewMessage={true}
                            UniqId={uniqId}
                            GroupIDs={groupIds}
                            PhoneNumbers={phoneNumbers}
                            IsDisabled={isDisabled()}
                            Limit={limit}
                            UnsubscribedCount={unsubscribedCount}
                            BlockedCount={blockedCount}
                            ContactIDs={contactIds}
                            ScheduledMessageID={props.ScheduledMessageID}
                            IsDuplicate={props.IsDuplicate}
                            HandleScheduleTypeChange={handleScheduleTypeChange}
                            showSignature={props.showSignature}
                            bodySign={props.bodySign}
                            signLength={props.signLength}
                            handleSuccess={props.handleSuccess}
                            IsAddRule={false}
                            Campaign={campaign}
                            IsCamPaign={props.IsCampaign}
                            MultiMedia={props.MultiMedia}
                            IsSecureChat={props.IsSecureChat}
                            ParticipantId={props.ParticipantID}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog >
    )
}

export default SendMessageComponent;
